export default "__VITE_ASSET__e56aff26__"